import { ReactNode } from 'react';
import styles from './Tags.module.scss';

export function Tags({ children }: { children: ReactNode }) {
  return <div className={styles.Tags}>{children}</div>;
}

export function Tag({
  onClick,
  readerLabel,
  visibleLabel,
}: {
  readerLabel: string;
  visibleLabel: string;
  onClick: () => void;
}) {
  return (
    <div className={styles.Tag}>
      <button onClick={onClick} type="button">
        {readerLabel}
      </button>
      <span aria-hidden="true">{visibleLabel}</span>
    </div>
  );
}
